import { Injectable } from '@angular/core';
import { AttachmentQuotation } from '../attachment-quotation';
import { GmailMessage } from '../gmail-message';

@Injectable({
  providedIn: 'root'
})
export class GmailService {

  constructor() { }

  getFormData(message: GmailMessage, quotations: AttachmentQuotation[]) {
    let formData = new FormData();
    let quotationIds = [];
    if (quotations.length > 0) {
      for (let quotation of quotations) {
        formData.append("files", quotation.file, quotation.file.name);
        quotationIds.push(quotation.quotationId);
      }
    }
    formData.append("quotationIds", new Blob([JSON.stringify(quotationIds)], {
      type: "application/json"
    }));
    formData.append("gmailMessage", new Blob([JSON.stringify(message)], {
      type: "application/json"
    }));
    return formData;
  }
}
